module.exports = require("ramda/src/propEq");